import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="document-payment-form"
export default class extends Controller {
  static targets = [ "paymentTypeSelect", "paymentBankName", "paymentDocumentNumber" ]

  paymentTypeChanged({ target }) {
    const paymentTypeData = target.options[target.selectedIndex]?.dataset || {}

    if (this.hasPaymentBankNameTarget) {
      this.paymentBankNameTarget.disabled = paymentTypeData.needsBankName !== "true"
    }
    if (this.hasPaymentDocumentNumberTarget) {
      this.paymentDocumentNumberTarget.disabled = paymentTypeData.needsDocumentNumber !== "true"
    }
  }

  setPaymentType(paymentTypeId) {
    if (!paymentTypeId || !this.hasPaymentTypeSelectTarget) return

    this.paymentTypeSelectTarget.value = paymentTypeId
    this.paymentTypeSelectTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
